module.exports = "<h1 style=margin-bottom:0 translate>Uw huuraanvraag</h1> <div class=wizard-nav> <div ng-repeat=\"step in vm.steps\" ng-class=\"$index === vm.activeStep ? 'active wizard-nav-item' : 'wizard-nav-item'\">{{step.value}}</div> </div>";


//////////////////
// WEBPACK FOOTER
// ./features/rental/components/rental-checkout-wizard/rental-wizard-menu.html
// module id = 648
// module chunks = 0